import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const LocationsList = styled.div`
  display: flex;
  flex-direction: column;

  & > :nth-child(odd) {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const LocationRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const LocationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  flex: 1;
`

export const ChipsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
